const Header = ({ text, className }) => {
  return (
    <h1
      className={`w-auto text-2xl font-bold text-slate-900  2xl:text-5xl leading-tight ${className}`}
    >
      {text}
    </h1>
  )
}

export default Header
